module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-message",
    style: (("background-color: " + (_vm.success ? '#6fc387' : '#ed6464')))
  }, [(_vm.success) ? _c('p', [_vm._v("\n\t\tGracias por su compra, el pago fue procesado,\n\t\tsu pedido fue realizado con exito.\n\t")]) : (!!_vm.errors[_vm.actionCode]) ? _c('p', [_vm._v("\n\t\t" + _vm._s(_vm.errors[_vm.actionCode].message) + "\n\t")]) : _c('p', [_vm._v("\n\t\tLo sentimos, el pago no pudo ser procesado,\n\t\tsu pedido ha sido cancelado.\n\t")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close-message')
      }
    }
  }, [_c('span', [_vm._v("x")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78262a38","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-message.vue
// module id = 1141
// module chunks = 2